import OrderPage from "./order-page";

export default OrderPage;